import './loader.scss';

function Loader() {
    const arr = [...Array(5)].map(x => 0);

    return (
        <div className="clip-tray-loader">
            {arr.map((x, i: number) => (
                <div className="clip-tray-card" key={i}>
                    <div className="clip-tray-card-header">
                        <div className="clip-tray-stream"></div>
                        <div className="clip-tray-title"></div>
                    </div>
                    <div className="clip-tray-card-body">

                    </div>
                </div>
            ))}
        </div>
    )
}

export default Loader;